###
# core JavaScript module for breathwithme.world
#
# Sebastian Vogel - sebastian at svogel dot net
###

###jslint         browser : true, continue : true,
 devel  : true, indent  : 2,    maxerr   : 50,
 newcap : true, nomen   : true, plusplus : true,
 regexp : true, sloppy  : true, vars     : false,
 white  : true, plusplus: true, unparam  : true, todo: true
###

###global jQuery ###

bwm = (($) ->
  'use strict'

  # region ---------- BEGIN MODULE SCOPE VARIABLES --------------

  cM =
    comeInLeftClasses : [
      'come-in-left'
      'come-in-left-top'
      'come-in-left-bottom'
    ]
    comeInRightClasses : [
      'come-in-right'
      'come-in-right-top'
      'come-in-right-bottom'
    ]
    phoneBreakpoint: 768
    desktopBreakpoint: 1024
    transition_duration: 1000
    showEnterArrowDelay: 7500
#    showEnterArrowDelay: 1500
    zitat_delay: 500
    scrollIn_next_delay: 2500
#    showEnterArrowDelay: 0
#    zitat_delay: 0
#    scrollIn_next_delay: 0
    autoloadPage01: true
    screenMenuRatio: 1.45
    resizeInterval: 50
    scrollInterval: 50


  sM =
    isHome: false
    winWidth: undefined
    winHeight: undefined
    winRatio: undefined
    isMobile: false
    isPhone: false
    isTablet: false
    whichMenu: undefined
    isFirstElemsSlidedIn: false
    breatherTable: undefined
    breatherIsEven: true
    resizeToId: undefined
    scrollToId: false

    worldMapWidth: undefined
    worldMapHeight: undefined
    activeShape: undefined

    headerIncVersion: '220816'
    breather_i : 0
    breather_loop_i : 1

    zoomRange: {
      old_min: 1,
      old_max: 10,
      new_min: 1,
      new_max: 4.5,
    }


  jM = {}
  setjqMap = undefined
  initModule = undefined


  # endregion ------- END MODULE SCOPE VARIABLES ---------------

  setjqMap = ->
    jM = {
      window: $ window
      body: $ 'body'
      quote: $ '#start_quote'
      logo: $ '#logo'
      content: $ '#content'
      nav_overlay: $ '#navigation_overlay'
      nav_link: $ 'a', '#navigation_overlay'

      menu_toggle:  $ '#nav_toggle'
      startpage_logo: $ '#logo_figure'
      next_link: $ '#next_link'
#      next_link: $ 'a', '#next_link'
      content_box: $ '.content-box'
      video: $ 'video'
      toggle_mute: $ '.toggle-mute'
      toggle_play: $ '.toggle-play'

      zitat_jeppe: $ '#life-begins-with-an'
      mail: $ '.mail'

      breathers_container: $ '#breathers_container'
    }
    return


  # region ---------- BEGIN JQUERY PLUGINS --------------


  ###*
  # inViewport jQuery plugin by Roko C.B.
  # http://stackoverflow.com/a/26831113/383904
  # Returns a callback function with an argument holding
  # the current amount of px an element is visible in viewport
  # (The min returned value is 0 (element outside of viewport)
  ###

  $.fn.inViewport = (cb) ->
    @each (i, el) ->

      visPx = ->
        elH = $(el).outerHeight()
        H = jM.window.height()
        r = el.getBoundingClientRect()
        t = r.top
        b = r.bottom
        cb.call el, Math.max(0, if t > 0 then Math.min(elH, H - t) else Math.min(b, H))

      visPx()
      jM.window.on 'resize scroll orientationChange', visPx



  ###*
  # Copyright 2012, Digital Fusion
  # Licensed under the MIT license.
  # http://teamdf.com/jquery-plugins/license/
  #
  # @author Sam Sehnert
  # @desc A small plugin that checks whether elements are within
  #       the user visible viewport of a web browser.
  #       can accounts for vertical position, horizontal, or both
  ###

  $w = $(window)

  $.fn.visible = (partial, hidden, direction, container) ->
    if @length < 1
      return
    # Set direction default to 'both'.
    direction = direction or 'both'
    $t = if @length > 1 then @eq(0) else this
    isContained = typeof container != 'undefined' and container != null
    $c = if isContained then $(container) else $w
    wPosition = if isContained then $c.position() else 0
    t = $t.get(0)
    vpWidth = $c.outerWidth()
    vpHeight = $c.outerHeight()
    clientSize = if hidden == true then t.offsetWidth * t.offsetHeight else true
    if typeof t.getBoundingClientRect == 'function'
# Use this native browser method, if available.
      rec = t.getBoundingClientRect()
      tViz = if isContained then rec.top - (wPosition.top) >= 0 and rec.top < vpHeight + wPosition.top else rec.top >= 0 and rec.top < vpHeight
      bViz = if isContained then rec.bottom - (wPosition.top) > 0 and rec.bottom <= vpHeight + wPosition.top else rec.bottom > 0 and rec.bottom <= vpHeight
      lViz = if isContained then rec.left - (wPosition.left) >= 0 and rec.left < vpWidth + wPosition.left else rec.left >= 0 and rec.left < vpWidth
      rViz = if isContained then rec.right - (wPosition.left) > 0 and rec.right < vpWidth + wPosition.left else rec.right > 0 and rec.right <= vpWidth
      vVisible = if partial then tViz or bViz else tViz and bViz
      hVisible = if partial then lViz or rViz else lViz and rViz
      vVisible = if rec.top < 0 and rec.bottom > vpHeight then true else vVisible
      hVisible = if rec.left < 0 and rec.right > vpWidth then true else hVisible
      if direction == 'both'
        return clientSize and vVisible and hVisible
      else if direction == 'vertical'
        return clientSize and vVisible
      else if direction == 'horizontal'
        return clientSize and hVisible
    else
      viewTop = if isContained then 0 else wPosition
      viewBottom = viewTop + vpHeight
      viewLeft = $c.scrollLeft()
      viewRight = viewLeft + vpWidth
      position = $t.position()
      _top = position.top
      _bottom = _top + $t.height()
      _left = position.left
      _right = _left + $t.width()
      compareTop = if partial == true then _bottom else _top
      compareBottom = if partial == true then _top else _bottom
      compareLeft = if partial == true then _right else _left
      compareRight = if partial == true then _left else _right
      if direction == 'both'
        return ! !clientSize and compareBottom <= viewBottom and compareTop >= viewTop and compareRight <= viewRight and compareLeft >= viewLeft
      else if direction == 'vertical'
        return ! !clientSize and compareBottom <= viewBottom and compareTop >= viewTop
      else if direction == 'horizontal'
        return ! !clientSize and compareRight <= viewRight and compareLeft >= viewLeft
    return


  # endregion ---------- JQUERY PLUGINS --------------


  # region ---------- BEGIN UTILITY METHODS ------------------
  # example : getTrimmedString

  checkScrollSpeed = ((settings) ->
# in "ms" (higher means lower fidelity )

    clear = ->
      lastPos = null
      delta = 0
      return

    settings = settings or {}
    lastPos = undefined
    newPos = undefined
    timer = undefined
    delta = undefined
    delay = settings.delay or 50
    clear()
    ->
      newPos = window.scrollY
      if lastPos != null
# && newPos < maxScroll
        delta = newPos - lastPos
      lastPos = newPos
      clearTimeout timer
      timer = setTimeout(clear, delay)
      delta
  )()


  setCookieVisited = ->
#    console.log 'set cookie visited.'
    date = new Date
    date.setTime( date.getTime() + (2 * 365 * 24 * 60 * 60 * 1000) )
    expires = '; expires=' + date.toGMTString()
    document.cookie = 'visited=1' + expires + '; path=/'
    return

  hasSiteBeenVisited = ->
    ca = document.cookie.split(';')
    i = 0
#    console.log 'cookies: ', ca
    while i < ca.length
      c = ca[i]
      while c.charAt(0) == ' '
        c = c.substring(1, c.length)
      if c.indexOf('visited') == 0
        return true
      i++
    null


  # endregion ------- END UTILITY METHODS -------------------

  # region ---------- BEGIN INIT METHODS --------------------

  initHome = ->

#    jM.menu_toggle.fadeIn()
    jM.logo.fadeIn()
    jM.nav_overlay.fadeIn 2500

  initPages = ->
    # listen to "scroll" event
    if jM.body.hasClass 'page-worldwide'
      jM.logo.addClass 'scrolled'
    else
      jM.window.on 'scroll', ->
        if jM.window.scrollTop() > 40
          jM.logo.addClass 'scrolled'
        else
          jM.logo.removeClass 'scrolled'


    if jM.body.hasClass 'page-01'
      setTimeout ->
        jM.zitat_jeppe.animate({
          opacity: 1
        }, 3500 )
      , cM.zitat_delay


      setTimeout ->
#    jM.content_box.inViewport slideInWhenInViewport
        slideInVisibleElements()
        jM.window.on 'resize scroll orientationChange', slideInVisibleElements
      , cM.scrollIn_next_delay

    else
      slideInVisibleElements()
      jM.window.on 'resize scroll orientationChange', slideInVisibleElements

      if jM.body.hasClass 'page-worldwide'

        jM.worldmapContainer = $ '#worldmap_container'
        jM.worldmap = $ '#worldmap'
        jM.customShapesMenu = $ '#custom_shapes_menu'
        jM.customShapesMenuItems = $ '#custom_shapes_menu li'
        if sM.isMobile
          setWorldMap()
          jM.customShapesMenuItems.click (e) ->
            if sM.activeShape
              $.imageMapProHideTooltip('Worldwide Projects 2022 mobile', sM.activeShape)
            sM.activeShape = $(e.target).data 'shape-title'
            $.imageMapProOpenTooltip('Worldwide Projects 2022 mobile', sM.activeShape)
          jM.worldmapContainer.click ->
            if sM.activeShape
              $.imageMapProHideTooltip('Worldwide Projects 2022 mobile', sM.activeShape)
        else
          checkInitializedInterval = setInterval ->
            console.log('run interval', jM.worldmap.hasClass 'imp-initialized')
            if jM.worldmap.hasClass 'imp-initialized'
              clearInterval(checkInitializedInterval)
              setTimeout ->
                setWorldMap()
              , 1000
    #          jM.worldmapContainer.one 'mouseenter', ->
    #            setWorldMap()
          , 50

      if jM.body.hasClass 'page-breathers'
        sM.breatherTable = if jM.body.hasClass 'page-first-breathers' then 'firstbreathers' else 'worldbreathers'
        url = '/includes/get_breathers_json.php?table=' + sM.breatherTable
        $.ajax
          url: url
          method: 'GET'
          success: (resp) ->
            breathers = $.parseJSON(resp).breathers
#            console.log 'breathers: ', breathers
            maxVal = if sM.breatherTable == 'firstbreathers' then 2 else 1
            for i in [0..maxVal]
#              console.log 'i: ', i
              addBreather(breathers[sM.breather_i])

            jM.window.scroll ->
              if sM.scrollToId
                false
              else

                if (document.scrollingElement.scrollTop - ( jM.content.height() - sM.winHeight )) > sM.winHeight / -2 and sM.breather_i < breathers.length
                  addBreather(breathers[sM.breather_i])

                sM.scrollToId = setTimeout((->
                  sM.scrollToId = undefined
                  return
                ), cM.scrollInterval)

          error: ( jqXHR, textStatus, errorThrown ) ->
            console.warn jqXHR, textStatus, errorThrown


  setBreatherLoopIndex = ->
    if sM.breatherTable == 'firstbreathers' && sM.breather_loop_i > 6 then sM.breather_loop_i = 1
    else if sM.breatherTable == 'worldbreathers' && sM.breather_loop_i > 5 then sM.breather_loop_i = 1

  # endregion ------- END INIT METHODS -------------------

  # region ---------- BEGIN DOM METHODS --------------------

  addBreather = (breather) ->
#    console.log 'addBreather: ', breather
#    console.log 'breather loop i: ', sM.breather_loop_i

    if sM.breatherTable == 'firstbreathers'
      $breather = $(
        [
          "<div class='breather-item cf'>",
          "  <div class='content-box box-video box-" + (if sM.breatherIsEven then 'right' else 'left') + " video" + sM.breather_loop_i + " cf'>",
          "    <div class='video-div'>",
          "      <div class='vimeo-video'>",
          "        <iframe src='https://player.vimeo.com/video/" + breather.vimeo_id + "' width='640' height='360' frameBorder='0' allow='autoplay; fullscreen' allowFullScreen></iframe>",
          "      </div>",
          "      <p class='subtitle'>" + breather.name + "</p>",
          "    </div>",
          "  </div>",
          "</div>"
        ].join("\n")
      )

    else
      $breather = $(
        [
          "<div class='world-breather-row row-content-" + (if sM.breatherIsEven then 'left' else 'right') + " wbr-" + sM.breather_loop_i + "'>",
          "  <div class='breather-item cf wbi-1'>",
          "    <div class='content-box box-video box-" + (if sM.breatherIsEven then 'left' else 'right') + " cf'>",
          "      <div class='video-div'>",
          "        <div class='vimeo-video'>",
          "          <iframe src='https://player.vimeo.com/video/" + breather.vimeo_id + "' width='640' height='360' frameBorder='0' allow='autoplay; fullscreen' allowFullScreen></iframe>",
          "        </div>",
          "        <p class='subtitle'>" + breather.name + "</p>",
          "      </div>",
          "    </div>",
          "  </div>",
          "  <div class='breather-item cf wbi-2'>",
          "    <div class='content-box box-video box-" + (if sM.breatherIsEven then 'right' else 'left') + " cf'>",
          "      <div class='video-div'>",
          "        <div class='vimeo-video'>",
          "          <iframe src='https://player.vimeo.com/video/" + breather.vimeo_id_doku + "' width='640' height='360' frameBorder='0' allow='autoplay; fullscreen' allowFullScreen></iframe>",
          "        </div>",
          "        <p class='subtitle'>" + breather.name + "</p>",
          "      </div>",
          "    </div>",
          "  </div>",
          "</div>"
        ].join("\n")
      )

      if breather.testimonial == undefined || breather.testimonial.length < 1
        $breather.addClass 'no-testimonial'

    if breather.profession != undefined && breather.profession.length > 0
      $subtitle = $breather.find( 'p.subtitle')
      $subtitle.each ->
        text = $(this).text() + ', ' + breather.profession
        $(this).text(text)

    if breather.testimonial != undefined && breather.testimonial.length > 0
      testimonial_horizontal_class = if sM.breatherIsEven then "right" else "left"
      $testimonial = $(
        [
          "<div class='content-box box-text box-" + (if sM.breatherIsEven then 'left' else 'right') + " testimonial quote" + sM.breather_loop_i + "'>",
          "  <div>",
          "    <p>",
          "      &ldquo;&nbsp;" + breather.testimonial + "&nbsp;&rdquo;",
          "    </p>",
          "    <p class='small'>" + breather.name + "</p>",
          "  </div>",
          "</div>",
        ].join("\n")
      )

      if sM.breatherTable == 'firstbreathers'
        $breather.append $testimonial
      else
        $breather.find('.wbi-2').append($testimonial)


#    console.log '$breather: ', $breather

    jM.breathers_container.append($breather)
    slideInVisibleElements()

    sM.breatherIsEven = !sM.breatherIsEven
    sM.breather_i += 1
    sM.breather_loop_i += 1
    setBreatherLoopIndex()


  slideInVisibleElements = (e) ->
#    console.log 'slideInVisibleElements called ', e
    jM.content_box = $ '.content-box'
    jM.content_box.each (i, el) ->
      el = $(el)
      if el.visible(true) && !el.hasClass 'come-in'
        index = Math.floor(Math.random() * 3)
        if el.hasClass 'box-left'
          el.addClass 'come-in-bottom-1'
#          el.addClass cM.comeInLeftClasses[index]
        else if el.hasClass 'box-right'
          el.addClass 'come-in-bottom-2'
        el.addClass 'come-in'

        img = el.find('img[data-src]')
        if img.length > 0
          sizes = img.data 'sizes'
          srcset = img.data 'srcset'
          src = img.data 'src'
          img.attr(
            'sizes': sizes
            'srcset': srcset
            'src': src
          )

        sM.isFirstElemsSlidedIn = true


  encodeEmails = (elem) ->
    $this = $(elem)
    target = $this.data('name') || 'info'
    domain = $this.data('domain') || 'breathewithme.world'
    link = target + '@' + domain
    link_classes = $this.data 'link_classes'
    link_text = link.replace('-', '&#8209;')
    text = $this.text() || link_text
    subject = $this.data 'subject'
    if subject
      link += '?subject='+subject

    $mailto_link = $('<a/>').attr(href: 'mailto:' + link).html(text)
    if link_classes then $mailto_link.addClass link_classes
    $this.html $mailto_link


  lazyload = ->
    if sM.scrollToId
      clearTimeout sM.scrollToId
    sM.scrollToId = setTimeout((->
      scrollTop = window.pageYOffset
      lazyloadImages.forEach (img) ->
        if img.offsetTop < window.innerHeight + scrollTop
          img.src = img.dataset.src
          img.classList.remove 'lazy'
        return
      if lazyloadImages.length == 0
        document.removeEventListener 'scroll', lazyload
        window.removeEventListener 'resize', lazyload
        window.removeEventListener 'orientationChange', lazyload
      return
    ), 20)
    return



  # End DOM method /setjqMap/

  # endregion ------- END DOM METHODS ---------------------

  # region ---------- BEGIN EVENT HANDLERS -------------------
  # example: onClickButton = ...

  setWorldMap = ->
    jM.worldmapContainer.addClass 'fullscreen'
    setTimeout( ->
      sM.worldMapWidth = jM.worldmapContainer.width()
      sM.worldMapHeight = jM.worldmapContainer.height()
      document.documentElement.style.setProperty(
        "--map-height",
        sM.worldMapHeight + 'px'
      )
      worldmapHeight = jM.worldmapContainer.height()
      worldmapOverflowBottom = Math.round(worldmapHeight - sM.winHeight)
      worldmapOverflowBottom = if worldmapOverflowBottom < 0 then 0 else worldmapOverflowBottom
      console.log('worldmapOverflowBottom', worldmapOverflowBottom)
      document.documentElement.style.setProperty(
        "--map-legends-bottom",
        worldmapOverflowBottom + 'px'
      )
      document.documentElement.style.setProperty(
        "--map-tooltips-top",
        sM.winHeight + 'px'
      )

#      jM.customShapesMenu.height( sM.winHeight - sM.worldMapHeight - 125)
#      $('.imp-shapes-menu-wrap').css 'maxHeight', sM.worldMapHeight - 150
      if sM.isMobile
        jM.body.css 'paddingTop', sM.worldMapHeight + 14


    , 1000)

    if !sM.isMobile
      setInterval( ->
        if !jM.worldZoomWrapper || jM.worldZoomWrapper.length < 1
          jM.worldZoomWrapper = $ '.imp-zoom-wrap'
        if !jM.impShapeTitles || jM.impShapeTitles.length < 1
          jM.impShapeTitles = $ '.imp-shapes-menu-shape-title'
          if jM.impShapeTitles
            $(".imp-shapes-menu-shape-title").click (e) ->
              if sM.activeShape
                $.imageMapProHideTooltip('Worldwide Projects 2022', sM.activeShape)
              sM.activeShape = $(e.target).data 'imp-content'
              console.log('click shape', sM.activeShape)
              $.imageMapProOpenTooltip('Worldwide Projects 2022', sM.activeShape)

            $('.imp-shapes-menu-wrap').mouseleave ->
              if sM.activeShape
                $.imageMapProHideTooltip('Worldwide Projects 2022', sM.activeShape)



        if(jM.worldZoomWrapper)
          style = jM.worldZoomWrapper.attr('style')
#          console.log('worldZoomWrapper, style', jM.worldZoomWrapper, style)
          if style
            regex = /scale\((.*),/
            found = style.match regex
            if found && found[1]
              scale = parseInt found[1]
#              console.log('watch zoom scale:', scale)

              dot_scale = ( (scale - sM.zoomRange.old_min) / (sM.zoomRange.old_max - sM.zoomRange.old_min) ) * (sM.zoomRange.new_max - sM.zoomRange.new_min) + sM.zoomRange.new_min
              console.log('dot scale:', dot_scale)
              document.documentElement.style.setProperty(
                "--project-dots-scale",
                1.2 / dot_scale
              );

      , 50)

  onResize = ->
    if sM.resizeToId
      false

    else
      sM.winHeight = jM.window.height()
      sM.winWidth = jM.window.width()
      sM.winRatio = sM.winWidth / sM.winHeight
      #      sM.header_height = jM.header.innerHeight()

      whichMenu = sM.whichMenu

      #      region SET sM and HTML-body MOBILE CLASS
      if sM.winWidth < cM.phoneBreakpoint || sM.winHeight <= 600
        jM.body.removeClass 'tablet'
        jM.body.addClass 'phone'
        sM.isPhone = true
        sM.isTablet = false
      else if sM.winWidth < cM.desktopBreakpoint
        jM.body.removeClass 'phone'
        jM.body.addClass 'tablet'
        sM.isPhone = false
        sM.isTablet = true
      else
        jM.body.removeClass 'tablet'
        jM.body.removeClass 'phone'
        sM.isPhone = false
        sM.isTablet = false

      if sM.isMobile and sM.winHeight > sM.winWidth
        jM.body.addClass 'portrait'
      else
        jM.body.removeClass 'portrait'

      if sM.winWidth < cM.desktopBreakpoint
        sM.zoomRange.new_max = 2.5
      else
        sM.zoomRange.new_max = 4.5

      #      endregion

      #      region LOAD MENU /w images or as table AND SET ALIGN-CLASS for menu image items
      if ( sM.winWidth >= 900 and sM.winHeight >= 548 ) or ( sM.winWidth >= 748 and sM.winHeight > sM.winWidth )
        sM.whichMenu = 'images'
      else
        sM.whichMenu = 'table'

      if whichMenu != sM.whichMenu
        $('.main-nav-div').remove()
        url = '/header_inc/menu_table.inc.html?v=250616'
        if sM.whichMenu == 'images'
          url = '/header_inc/menu_images.inc.html?v=250616'

        $.ajax({
          url : url + '?v='+sM.headerIncVersion
          type : 'GET'
          success : (response) ->
            jM.nav_overlay.prepend $(response)

          error: ( jqXHR, textStatus, errorThrown ) ->
            console.log(jqXHR, textStatus, errorThrown)
        })


      if sM.winWidth / sM.winHeight > cM.screenMenuRatio
        jM.nav_overlay.removeClass 'items-by-width'
        jM.nav_overlay.addClass 'items-by-height'
      else
        jM.nav_overlay.removeClass 'items-by-height'
        jM.nav_overlay.addClass 'items-by-width'


      if jM.worldmapContainer
        sM.worldMapWidth = jM.worldmapContainer.width()
        sM.worldMapHeight = jM.worldmapContainer.height()
        document.documentElement.style.setProperty(
          "--map-height",
          sM.worldMapHeight + 'px'
        )

        worldmapOverflowBottom = Math.round(sM.worldMapHeight - sM.winHeight)
        worldmapOverflowBottom = if worldmapOverflowBottom < 0 then 0 else worldmapOverflowBottom
        console.log('worldmapOverflowBottom', worldmapOverflowBottom)
        document.documentElement.style.setProperty(
          "--map-legends-bottom",
          worldmapOverflowBottom + 'px'
        )
        document.documentElement.style.setProperty(
          "--map-tooltips-top",
          sM.winHeight + 'px'
        )

#        jM.customShapesMenu.height( sM.winHeight - sM.worldMapHeight - 125)
#        $('.imp-shapes-menu-wrap').css 'maxHeight', sM.worldMapHeight - 150

        if sM.isMobile
          jM.body.css 'paddingTop', sM.worldMapHeight


      #      endregion

      #      console.log 'stateMap: ', sM
      sM.resizeToId = setTimeout((->
        sM.resizeToId = undefined
        return
      ), cM.resizeInterval)
      true


  # endregion ------- END EVENT HANDLERS --------------------

  # region ---------- BEGIN PUBLIC METHODS -------------------
  # Begin public method /initModule/
  # Purpose    : Initializes module
  # Arguments  :
  #  * $container the jquery element used by this feature
  # Returns    : true
  # Throws     : none
  #

  initModule = ->
    setjqMap()

    if jM.body.hasClass('home') then sM.isHome = true
    if jM.body.hasClass('mobile') then sM.isMobile = true

    initPages()


    # PRELOAD LOGO IMAGES
    logo_big = (new Image()).src = '/assets/img/logo/breathe-with-me_Logo_710.png'
    logo_small = (new Image()).src = '/assets/img/logo/breathe-with-me_Logo_355.png'
    logo_phone = (new Image()).src = '/assets/img/logo/breathe-with-me_Logo_160.png'

    jM.window.on 'resize orientationChange', onResize
    onResize()


    jM.menu_toggle.on 'click', ->
      jM.body.toggleClass 'menu-open'
      if sM.activeShape
        $.imageMapProHideTooltip('Worldwide Projects 2022 mobile', sM.activeShape)


    jM.nav_link.on 'click', (e) ->
      e.preventDefault()
      $this = $(this)
#      console.log 'target: ', $this.attr('target')
      if $this.attr('target') == '_blank'
        jM.menu_toggle.trigger 'click'
        return true;
      else
        if sM.isHome
          jM.quote.remove()
        target = $this.attr 'href'
        jM.menu_toggle.trigger 'click'
        jM.content.fadeOut 1000
        setTimeout ->
          window.location.href = target
        , cM.transition_duration
        false


    jM.mail.each ->
      encodeEmails(this)

    true

  # End public method /initModule/
  # return public methods
  {
    initModule: initModule
    jM: jM
  }

# endregion ------- END PUBLIC METHODS ---------------------

)(jQuery)

jQuery ->
  bwm.initModule()
  return

